import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ConvertAttribute: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 264 126">
    <svg fill="none">
      <path fill="#F9FBFD" d="M0 0h264v125.832H0z" />
      <rect
        opacity={0.4}
        x={139.25}
        y={44}
        width={95}
        height={38}
        rx={4.75}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={168.938}
        y={55.875}
        width={53.438}
        height={4.75}
        rx={2.375}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={168.938}
        y={66.563}
        width={34.438}
        height={4.75}
        rx={2.375}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <circle opacity={0.4} cx={155.875} cy={63} r={9.5} fill="#2962FF" fillOpacity={0.3} />
      <rect
        opacity={0.4}
        x={30}
        y={53.5}
        width={54.625}
        height={15.438}
        rx={7.719}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <path
        d="M128.982 61.639a.594.594 0 0 0 0-.84l-3.778-3.779a.594.594 0 0 0-.84.84l3.359 3.359-3.359 3.358a.594.594 0 1 0 .84.84l3.778-3.778Zm-33.67.173h33.25v-1.187h-33.25v1.188Z"
        fill="#000"
        fillOpacity={0.1}
      />
    </svg>
  </SvgIcon>
);

export default ConvertAttribute;
